import React from 'react'
import * as Styles from './layout.styles'
import * as service from './layout.service'
import { StylesProvider } from '@material-ui/core/styles'

type Props = {
  children: JSX.Element
}

const Layout: React.FC<any> = (props: Props) => {
  service.loadFonts()

  return (
    <React.Fragment>
      <StylesProvider injectFirst>
        <Styles.Html />
        <Styles.Body />
        {props.children}
      </StylesProvider>
    </React.Fragment>
  )
}

export default Layout
